import request, { downloadFile, getServiceFile } from '../service';
import businessRequest from '../business-service';
import { Message } from 'element-ui';

const config = {
    // baseURL: 'http://10.40.53.87:16630/',
    // headers: {
    //     'Internal-Token' : '{"account":"15018735011"}'
    // }
}
const prefix = 'manager';

// 分页查询人脸库
interface GetFaceLibraryType {
    name: string;
    pageNo: number;
    pageSize: number;
    projectId: string;
}
export function getFaceLibrary(params: GetFaceLibraryType) {
    return businessRequest.get(
        `${prefix}/v1/face/group/page`,
        {
            params,
            ...config,
        },
    );
}

// 人脸库统计
interface GetFaceLibrarySummaryType {
    projectId: string;
}
export function getFaceLibrarySummary(params: GetFaceLibraryType) {
    return businessRequest.get(
        `${prefix}/v1/face/group/summary`,
        {
            params,
            ...config,
        },
    );
}

// 创建人脸库
interface PostFaceLibraryType {
    name?: string;
    tags?: string[];
    projectId?: string;
    valid?: boolean;
}
export function postFaceLibrary(data: PostFaceLibraryType) {
    return businessRequest.post(
        `${prefix}/v1/face/group`,
        data,
        {
            ...config,
        }
    );
}

// 更新人脸库
interface PutFaceLibraryType extends PostFaceLibraryType {
    id: string;
}
export function putFaceLibrary(data: PutFaceLibraryType) {
    return businessRequest.put(
        `${prefix}/v1/face/group`,
        data,
        {
            ...config,
        }
    );
}

// 删除人脸库
interface DeleteFaceLibraryType {
    id: string;
}
export function deleteFaceLibrary(params: DeleteFaceLibraryType) {
    return businessRequest.delete(
        `${prefix}/v1/face/group`,
        {
            params,
            ...config,
        }
    );
}

// 获取人脸库内容
interface GetFaceLibraryDetailType {
    id: string;
}
export function getFaceLibraryDetail(params: GetFaceLibraryDetailType) {
    return businessRequest.get(
        `${prefix}/v1/face/group`,
        {
            params,
            ...config,
        },
    );
}

// 批量增加人脸库标签
interface PutFaceLibraryTagsType {
    groups: string[];
    tags: string[];
}
export function putFaceLibraryTags(data: PutFaceLibraryTagsType) {
    return businessRequest.post(
        `${prefix}/v1/face/group/batch/tag`,
        data,
        {
            ...config,
        }
    );
}

// 分页获取人脸
interface GetFaceLibraryFaceType {
    name: string;
    pageNo: number;
    pageSize: number;
    groupId: string;
}
export function getFaceLibraryFace(params: GetFaceLibraryFaceType) {
    return businessRequest.get(
        `${prefix}/v1/face/group/face/page`,
        {
            params,
            ...config,
        },
    );
}

// 创建人脸
interface PostFaceLibraryFaceType {
    groupId: string;
    images: string[];
    name: string;
    sex: string;
}
export function postFaceLibraryFace(data: PostFaceLibraryFaceType) {
    return businessRequest.post(
        `${prefix}/v1/face/group/face`,
        data,
        {
            ...config,
        }
    );
}

// 更新人脸
interface PutFaceLibraryFaceType extends PostFaceLibraryFaceType {
    faceId: string;
}
export function putFaceLibraryFace(data: PutFaceLibraryFaceType) {
    return businessRequest.put(
        `${prefix}/v1/face/group/face`,
        data,
        {
            ...config,
        }
    );
}

// 上传并校验人脸
export const uploadFaceImage = (data, config) => {
    return request.post(
        `${prefix}/v1/face/group/face/image`,
        data,
        Object.assign(
            {},
            {
                timeout: 60 * 1000,
            },
            config,
        ),
    );
};

// 删除人脸
interface DeleteFaceLibraryFaceType {
    ids: string;
}
export function deleteFaceLibraryFace(data: DeleteFaceLibraryFaceType) {
    return businessRequest.delete(
        `${prefix}/v1/face/group/face`,
        {
            data,
            ...config,
        },
    );
}

// 获取人脸照片
interface GetFaceImageType {
    path: string;
}
export function getFaceImage(params: GetFaceImageType, cancelTokenFunc?) {
    return getServiceFile(`${prefix}/v1/face/group/face/image`, params, cancelTokenFunc);
}

// 批量操作 批量导入/追加
export const batchOptImport = (data: any) => {
    return request.post(
         `${prefix}/v1/face/group/face/import`,
        data,
        {
            ...config,
        }
    ).then(res => res.data);
};


// 批量操作 导出问答
export const batchOptExport = data => {
    return request.post(
        `${prefix}/v1/face/group/face/export`,
        data,
        {
            ...config,
        }
    ).then(res => res.data);
};

// 下载模板
export const batchOptDownloadTemplate = (path, fileName) => {
    // dev CORS
    downloadFile(`${process.env.VUE_APP_STATIC_RES_BASE_URL}download/template/${path}`, fileName, 'zip')
        .catch(err => {
            Message.error(err.message);
        });
};

// 获取批量导入任务状态
interface GetImportResultType {
    id: string;
}
export const getImportResult = (params: GetImportResultType) => {
    return businessRequest.get(
        `${prefix}/v1/face/group/face/import/result`,
        {
            params,
            ...config,
        },
    ).then(res => res.data || {});
};

// 获取批量导出任务状态
interface GetExportResultType {
    id: string;
}
export const getExportResult = (params: GetExportResultType) => {
    return businessRequest.get(
        `${prefix}/v1/face/group/face/export/result`,
        {
            params,
            ...config,
        },
    ).then(res => res.data || {});
};


// 生成许入码
interface GetEntryCodeType {
    id: string;
    maxFaces: number;
}
export const getEntryCode = (params: GetEntryCodeType) => {
    return businessRequest.get(
        `${prefix}/v1/face/group/entryCode`,
        {
            params,
            ...config,
        },
    );
};
